import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { openAiAssistant } from '../../../../sagas/aiAssistant/actions';
import { setSuggestionsToDisplay } from '../../../../sagas/aiPromptSuggestions/actions';
import { openPricingModal } from '../../../../sagas/pricingModal/actions';
import { ReactComponent as SparklesIcon } from '../../../../assetsNew/icons/ai/sparkles.svg';
import { isAiAssistantVisiblePath, isAiAssistantBarPath } from '../../../../utils/menu';
import { AI_ASSISTANT_SHORTCUT_LABEL, isAiAssistantShortcut } from '../../shortcut';

import './_aiAssistantBar.scss';

const AIAssistantBar = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { open } = useSelector(state => state.aiAssistant || { open: false });
  const { navbar, menu } = useSelector(state => state.layout);
  const { data: subscriptionData } = useSelector(state => state.getBillingSubscriptionInfo);
  const isVisible = (navbar || menu) && isAiAssistantVisiblePath(pathname) && isAiAssistantBarPath(pathname);
  const hasAccess = Boolean(subscriptionData.can_access_ai_chat);

  const handleOpen = useCallback(() => {
    if (!hasAccess) {
      dispatch(openPricingModal());
      return;
    }
    dispatch(setSuggestionsToDisplay(null));
    dispatch(openAiAssistant('floating'));
  }, [dispatch, hasAccess]);

  useEffect(() => {
    if (!isVisible || open) {
      return undefined;
    }

    const handleKeyDown = event => {
      if (!isAiAssistantShortcut(event)) return;

      event.preventDefault();
      handleOpen();
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleOpen, isVisible, open]);

  if (!isVisible || open) {
    return null;
  }

  return (
    <button className="aiAssistantBar" onClick={handleOpen} type="button" aria-label="Open AI assistant">
      <span className="aiAssistantBar-badge">
        <SparklesIcon />
      </span>
      <span className="aiAssistantBar-placeholder">Ask for insights or next steps…</span>
      <span className="aiAssistantBar-shortcut">{AI_ASSISTANT_SHORTCUT_LABEL}</span>
    </button>
  );
};

export default AIAssistantBar;
